module.exports = __webpack_public_path__ + "static/tasks-web3-5b1c180e745d0b90037f36877560d983.png";